import React from "react"
import { ButtonGroupProps, ButtonGroup } from "@blueprintjs/core"
import classNames from "utils/classNames"

interface CustomButtonGroupProps extends ButtonGroupProps {
  /**
   * Denotes whether the buttons inside the button group are connected together
   * This is taken as a seperate prop for backwards conpatibility and greater flexibility
   */
  joint?: boolean
}
const CustomButtonGroup = ({
  className,
  joint,
  children,
  ...props
}: CustomButtonGroupProps) => {
  return (
    <ButtonGroup
      className={classNames(
        "vt-custom-button-group",
        {
          "vt-custom-button-group-joint": joint,
        },
        className
      )}
      {...props}
    >
      {children}
    </ButtonGroup>
  )
}

export default CustomButtonGroup
